import { useEffect } from 'react';
import { Outlet, useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isApp } from '../common/bridge';
import { isUrlLocale, buildLocalePath } from '../common/utils/locale.utils';
import { DEFAULT_LOCALE, LOCALE_UZ, LOCALE_RU } from '../common/constants';

const URL_LOCALES = [LOCALE_UZ, LOCALE_RU];

export const LanguageLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!lang) {
      if (!isApp()) {
        const preferred = i18n.language || DEFAULT_LOCALE;
        const targetLang = URL_LOCALES.includes(preferred) ? preferred : DEFAULT_LOCALE;
        navigate(buildLocalePath(targetLang, location.pathname + location.search), { replace: true });
      }
      return;
    }

    if (!isUrlLocale(lang)) {
      navigate(buildLocalePath(DEFAULT_LOCALE, location.pathname + location.search), { replace: true });
      return;
    }

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n, location.pathname, location.search, navigate]);

  return <Outlet />;
};
